export const POSTBACKS_METRICS = {
  allColumns: [
    'postbacks-timestamp',
    'postbacks-clickid',
    'postbacks-url',
    'postbacks-status_code',
    'postbacks-body',
    'postbacks-headers',
    'postbacks-error',
    'campaigns-id',
    'campaigns-name',
    'landings-id',
    'landings-name',
    'offers-id',
    'offers-name',
    'flows-id',
    'flows-name',
    'traffic_sources-id',
    'traffic_sources-name',
    'affiliate_networks-id',
    'affiliate_networks-name',
    'postbacks-status',
  ],
  defaultUnselected: [
    'offers-name',
    'flows-id',
    'flows-name',
    'traffic_sources-name',
    'postbacks-body',
    'postbacks-headers',
    'postbacks-error',
    'campaigns-id',
    'landings-id',
    'landings-name',
    'offers-id',
    'traffic_sources-id',
    'affiliate_networks-id',
    'affiliate_networks-name',
  ],
  defaultSelected: [
    'postbacks-timestamp',
    'postbacks-clickid',
    'postbacks-url',
    'postbacks-status_code',
    'campaigns-name',
    'offers-name',
    'traffic_sources-name',
    'postbacks-status',
  ],
  defaultSort: [
    'postbacks-timestamp',
  ],
  order: {
    orderBy: 'postbacks-timestamp',
    orderDir: 'desc',
  },
  weight: {},
  sortExclude:[]
}
